import React from 'react';
export function Footer() {
  return <footer className="bg-cream py-8 border-t border-warmgray text-center px-4" data-id="element-129" data-mp="32wd2qgad7ltj">
      <div className="max-w-4xl mx-auto" data-id="element-130" data-mp="3gg118925080a">
        <p className="text-charcoal-muted text-sm" data-id="element-131" data-mp="3gh3sii3dgcgq">
          © {new Date().getFullYear()} Massage Therapist Ready — All rights
          reserved.
        </p>
      </div>
    </footer>;
}